import type { ZodString } from "zod";
import { z } from "zod";

import { URL_BIBLE } from "../../../lib/constants/urls/urlBible";
import type { CloudfrontCookie } from "../../../lib/types/schema/cloudfrontCookieSchema";
import { signCFUrl } from "../../../lib/utils/signCFUrl";
import { useRequestQuery } from "../../../request/hooks/useRequestQuery";
import { keyBibleCSS } from "./keyBibleHTML";

type Props = {
  translationId: number;
  cookies: CloudfrontCookie[];
};

export const useRequestBibleCSS = ({ translationId, cookies }: Props) =>
  useRequestQuery<ZodString>({
    enabledWithoutSessionToken: true,
    queryFnRequestProps: {
      schema: z.string(),
      url: signCFUrl(
        `${URL_BIBLE}/translations/book/${translationId}/${translationId}.css`,
        cookies,
      ),
      requestType: "other",
      raw: true,
    },
    queryKey: keyBibleCSS({
      cookies: JSON.stringify(cookies),
      translationId,
    }),
  });
